import { Fragment, useEffect, useState } from 'react';
import "../FilePage/FilePage.css";
import SidePanel from '../../Components/SidePanel/SidePanel';
import Form from 'react-bootstrap/Form';
import Table from "react-bootstrap/Table";
import Paginations from '../../Components/Paginations/Paginations';
import { useNavigate } from 'react-router-dom';
import FilePageService from '../../API/FilePage/FilePageService';
import { useTranslation } from 'react-i18next';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Loading from '../../Common/Loading';
import { BsPatchExclamation } from 'react-icons/bs';

const QRBasisList = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [qrBasisList, setQRBasisList] = useState([]);

    const [qrBasisStatus, setQRBasisStatus] = useState("");
    const [updateQRBasisStatus, setUpdateQRBasisStatus] = useState("");
    const [qrBasisId, setQRBasisId] = useState("");
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [logoImageShow, setLogoImageShow] = useState("");
    const [rightPanelThemeColor, setRightPanelThemeColor] = useState("");
    const [isRotated, setIsRotated] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);
    const [sort, setSort] = useState({ key: "created_at", value: "desc" });

    const [showmodal, setShowmodal] = useState(false);
    const handleModalShow = () => setShowmodal(true);
    const handleModalClose = () => setShowmodal(false);

    const [showAddcol, setShowAddcol] = useState(false);
    const handleAddcolClose = () => setShowAddcol(false);
    const handleAddcolShow = () => setShowAddcol(true);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);


    const [modalColumns, setModalColumns] = useState({
        Nom: true,
        // "Produit assureur": true,
        "Créé par": true,
        status: true,
    });

    const [selectedColumns, setSelectedColumns] = useState(
        Object.keys(modalColumns).filter((key) => modalColumns[key])
    );

    useEffect(() => {
        if (deletePermission) {
            setModalColumns((prev) => ({
                ...prev,
                Action: true,
            }));
            const newSelectedColumns = Object.keys(modalColumns).filter(
                (key) => modalColumns[key]
            );
            newSelectedColumns.push("Action");
            setSelectedColumns(newSelectedColumns);
        }
    }, [deletePermission]);

    useEffect(() => {
        const userRole = JSON.parse(localStorage.getItem("userRole"));
        const token = localStorage.getItem("authToken");
        const can_delete_folder = JSON.parse(localStorage.getItem("can_delete_folder"));
        setDeletePermission(can_delete_folder == 1 ? true : false);
        if (token && userRole.includes("Administrateur")) {
            const logo_image = JSON.parse(localStorage.getItem("logo_image"));
            const right_panel_color = JSON.parse(localStorage.getItem("right_panel_color"));
            setRightPanelThemeColor(right_panel_color);
            setLogoImageShow(logo_image);
            QRBasisList(search, sort, currentPage, qrBasisStatus);
        } else {
            navigate("/");
        }
    }, [sort]);

    const QRBasisList = async (search, sort, page = 1, status) => {
        setIsLoading(true);
        try {
            var userData = {
                search: search,
                sort: {
                    key: sort.key,
                    value: sort.value
                },
                status: status,
                page
            }
            const response = await FilePageService.qr_basis_index(userData);
            if (response.data.status) {
                setIsLoading(false);
                setQRBasisList(response.data.qr_basis.data);
                setCurrentPage(response.data.qr_basis.meta.current_page);
                setTotalPages(response.data.qr_basis.meta.last_page);
                setTotalRecords(response.data.qr_basis.meta.total);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };

    const HandleDeleteDocumentFile = async () => {
        try {
            const response = await FilePageService.qr_basis_destroy(qrBasisId);
            if (response.data.status) {
                handleCloseDeleteModal();
                setQRBasisId("");
                QRBasisList(search, sort, currentPage, qrBasisStatus);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const HandleUpdateStatus = async () => {
        try {
            var useData = {
                status: updateQRBasisStatus == 1 ? "0" : "1",
            };
            const response = await FilePageService.qr_basis_update_status(qrBasisId, useData);
            if (response.data.status) {
                setQRBasisStatus("");
                QRBasisList(search, sort, currentPage, "");
                handleModalClose();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSearchChange = (search) => {
        setSearch(search);
        QRBasisList(search, sort, 1, qrBasisStatus);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearchChange(search);
        }
    };

    const HandleFilterStatus = (status) => {
        setQRBasisStatus(status);
        QRBasisList(search, sort, 1, status);
    };

    const handleStatusChange = (id, status) => {
        setQRBasisId(id);
        setUpdateQRBasisStatus(status);
        handleModalShow();
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        QRBasisList(search, sort, page, qrBasisStatus);
    };

    const handleCheckboxChange = (key) => {
        setModalColumns((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleAddcolSubmit = () => {
        const newSelectedColumns = Object.keys(modalColumns).filter(
            (key) => modalColumns[key]
        );
        setSelectedColumns(newSelectedColumns);
        handleAddcolClose();
    };

    const handleClickRotate = (column) => {
        const direction = sort.key === column ? sort.value === "desc" ? "asc" : "desc" : "asc";
        setSort({ key: column, value: direction });
        setIsRotated(!isRotated);
    };

    return (
        <Fragment>
            <style> {` button.btn.btn-primary  { background-color: ${localStorage.getItem('button_color') ? JSON.parse(localStorage.getItem('button_color')) : "#e84455"} !Important};`} </style>

            <SidePanel sidebarLogo={(logoImageShow != "" || logoImageShow != null || logoImageShow != undefined) && `${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`} />

            <div className="dashboard-main-content user-dashboard" style={{ backgroundColor: rightPanelThemeColor }}>
                <div className="top-header">
                    {/* <h4>Base QR</h4> */}
                    <div className="mt-3 d-md-flex justify-content-between align-items-center">
                        <h1 className="m-md-0 mb-3">Liste des bases QR</h1>
                    </div>
                </div>
                <div className="table-wrapper mt-24">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <Form.Group
                            className="relative"
                            controlId="exampleForm.ControlInput1"
                        >
                            <Form.Control
                                type="search"
                                placeholder="Rechercher"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={handleKeyPress}
                            />
                            <div
                                className="search-icon"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSearchChange(search)}
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.7549 11.2549H11.9649L11.6849 10.9849C12.6649 9.84488 13.2549 8.36488 13.2549 6.75488C13.2549 3.16488 10.3449 0.254883 6.75488 0.254883C3.16488 0.254883 0.254883 3.16488 0.254883 6.75488C0.254883 10.3449 3.16488 13.2549 6.75488 13.2549C8.36488 13.2549 9.84488 12.6649 10.9849 11.6849L11.2549 11.9649V12.7549L16.2549 17.7449L17.7449 16.2549L12.7549 11.2549ZM6.75488 11.2549C4.26488 11.2549 2.25488 9.24488 2.25488 6.75488C2.25488 4.26488 4.26488 2.25488 6.75488 2.25488C9.24488 2.25488 11.2549 4.26488 11.2549 6.75488C11.2549 9.24488 9.24488 11.2549 6.75488 11.2549Z"
                                        fill="#998f90"
                                    />
                                </svg>
                            </div>
                        </Form.Group>
                        <button onClick={() => navigate("/add-qr-basis")} className="btn btn-primary">
                            Ajouter une base QR
                        </button>
                    </div>

                    {isLoading ? <Loading /> :
                        <div className="table-wrap mt-24">
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        {selectedColumns.includes("Nom") &&
                                            <th>
                                                <div className="d-flex align-items-center">
                                                    <span>Nom</span>
                                                    <Link
                                                        className={`sorting-icon ms-2`}
                                                        onClick={() => handleClickRotate("name")}
                                                    >
                                                        {sort.value === "asc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                            </svg>
                                                        }

                                                        {sort.value === "desc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                            </svg>
                                                        }
                                                    </Link>
                                                </div>
                                            </th>
                                        }
                                        {selectedColumns.includes("Créé par") &&
                                            <th>
                                                <div className="d-flex align-items-center">
                                                    <span>{t("Créé par")}</span>
                                                    <Link
                                                        className={`sorting-icon ms-2`}
                                                        onClick={() => handleClickRotate("created_by")}
                                                    >
                                                        {sort.value === "asc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                            </svg>
                                                        }

                                                        {sort.value === "desc" &&
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                            </svg>
                                                        }
                                                    </Link>
                                                </div>
                                            </th>
                                        }
                                        {selectedColumns.includes("status") && (
                                            <th className="select-drop">
                                                <div className="d-flex align-items-center">
                                                    <div>
                                                        <Form.Select
                                                            aria-label="statusSelectAria"
                                                            value={qrBasisStatus}
                                                            onChange={(e) => HandleFilterStatus(e.target.value)}
                                                        >
                                                            <option value="">{t("status")}</option>
                                                            <option value={0}>{t("inActiveLabel")}</option>
                                                            <option value={1}>{t("activeLabel")}</option>
                                                        </Form.Select>
                                                    </div>
                                                    <div>
                                                        <Link
                                                            className={`sorting-icon ms-2`}
                                                            onClick={() => handleClickRotate("status")}
                                                        >
                                                            {sort.value === "asc" &&
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" />
                                                                    <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" fillOpacity="0.5" />
                                                                </svg>
                                                            }

                                                            {sort.value === "desc" &&
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="black" fillOpacity="0.5" />
                                                                    <path d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z" fill="black" />
                                                                </svg>
                                                            }
                                                        </Link>
                                                    </div>
                                                </div>
                                            </th>
                                        )}
                                        {selectedColumns.includes("Action") && deletePermission && <th>Action</th>}
                                        {/* <th style={{ textAlign: "right" }}>
                                            <Link onClick={handleAddcolShow}>
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 14 14"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black" />
                                                </svg>
                                            </Link>
                                        </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {(qrBasisList?.length > 0 && selectedColumns?.length > 0) ? (
                                        qrBasisList.map((data, index) => (
                                            <tr key={index}>
                                                {selectedColumns.includes("Nom") && (
                                                    <td className="bold-font">
                                                        <div style={{ lineHeight: 1 }}>
                                                            {data.is_important == 1 && <BsPatchExclamation style={{ color: "red", fontSize: "1.0rem", cursor: "pointer" }} title='Nom' />}
                                                            <div style={{ marginTop: "4px" }}>{data?.name}</div>
                                                        </div>
                                                    </td>
                                                )}
                                                {selectedColumns.includes("Créé par") && <td>{data.created_by_name}</td>}
                                                {selectedColumns.includes("status") &&
                                                    <td>
                                                        {data.status == 1 ?
                                                            <span className="verified badges" onClick={() => handleStatusChange(data.id, data.status)} style={{ cursor: "pointer" }}>
                                                                {t("activeLabel")}
                                                            </span>
                                                            :
                                                            <span className="incomplete badges" onClick={() => handleStatusChange(data.id, data.status)} style={{ cursor: "pointer" }}>
                                                                {t("inActiveLabel")}
                                                            </span>
                                                        }
                                                    </td>
                                                }
                                                {selectedColumns.includes("Action") && deletePermission && (
                                                    <td>
                                                        <div className="action-btn">
                                                            <Link
                                                                className="view"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    navigate(`/view-qr-basis/${data.id}`);
                                                                }}
                                                                title="Voir"
                                                            >
                                                                <svg
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z"
                                                                        fill="#00366B"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                            <Link
                                                                className="edit"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    navigate(`/edit-qr-basis/${data.id}`);
                                                                }}
                                                                title="Modifier"
                                                            >
                                                                <svg
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 6.19L2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19Z"
                                                                        fill="#00366B"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                            <Link
                                                                className="delete"
                                                                href="/user-management"
                                                                data-discover="true"
                                                                title="Supprimer"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleShowDeleteModal();
                                                                    setQRBasisId(data.id);
                                                                }}
                                                            >
                                                                <svg
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                                                        fill="#00366B"
                                                                    />
                                                                </svg>
                                                            </Link>
                                                        </div>
                                                    </td>
                                                )}
                                                {/* <td></td> */}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr style={{ textAlign: "center" }}>
                                            <td colSpan="11">{t("NorecordsfoundLabel")}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    }

                    {totalRecords > 10 &&
                        <Paginations
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            itemsPerPage={10}
                            totalItems={totalRecords}
                        />
                    }
                </div>
            </div>

            {/* Add Col Modal */}
            <Modal show={showAddcol} onHide={handleAddcolClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une colonne</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h2 className="mb-4">Liste des colonnes</h2>
                    {/* Select All Checkbox */}
                    <Form.Check
                        id="select-all-checkbox"
                        label="Sélectionner tout"
                        checked={Object.values(modalColumns).every((value) => value)} // All true
                        onChange={(e) => {
                            const isChecked = e.target.checked;
                            setModalColumns((prev) =>
                                Object.fromEntries(Object.keys(prev).map((key) => [key, isChecked]))
                            );
                        }}
                    />

                    {/* Individual Column Checkboxes */}
                    {Object.keys(modalColumns).map((key) => (
                        <Form.Check
                            key={key}
                            id={`checkbox-${key}`}
                            label={<label style={{ cursor: "pointer" }} htmlFor={`checkbox-${key}`}>{t(key)}</label>}
                            checked={modalColumns[key]}
                            onChange={() => handleCheckboxChange(key)}
                        />
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleAddcolSubmit}>
                        Ajouter
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Popup */}
            <Modal className="final-modal" show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title><h2>Confirmation</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Êtes-vous sûr de vouloir supprimer la base QR ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="cancel-btn" variant="primary" onClick={handleCloseDeleteModal}>
                        {t("cancelLabel")}
                    </Button>
                    <Button variant="primary" onClick={HandleDeleteDocumentFile}>
                        {t("confirmbtnLabel")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Confirmation Popup */}
            <Modal className='missing-doc-modal' show={showmodal} onHide={() => setShowmodal(true)}>
                <Modal.Header closeButton onHide={handleModalClose}>
                    <Modal.Title>
                        <h2>{t("confirmStatusTitle")}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="complete-process">
                        {t("confirmStatusMessage")}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <div className="text-end">
                        <Button variant="primary" onClick={() => HandleUpdateStatus()}>
                            {t("confirmbtnLabel")}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default QRBasisList;